import React from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import ModalStatistics from "../../components/modals/modalStatistics/ModalStatistics";
import "./novaposhta.scss";
import { NPSatuses, getStatusTitle } from "./NPSatuses";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import moment from "moment/moment";
import useDebounse from "../../helpers/useDebounse";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { PaginatedItems } from "../../components/pagination/Pagination";
import { useSelector } from "react-redux";

const Novaposhta = () => {
    const permissions = useSelector((state) => state.status.permissions);

    const [showStatisticModal, setShowStatisticModal] = useState(false);
    const [search, setSearch] = useState("");
    const [ttnList, setTtnList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const debounceSearch = useDebounse(search, 1000);

    const { statusParam } = useParams();

    const statusIdsParams =
        "&status_ids[]=" + NPSatuses.filter((st) => st.value === +statusParam)[0].status.join("&status_ids[]=");
    const searchParams = search.length > 0 ? `&search=${debounceSearch}` : "";
    const pagination = "&page=" + currentPage;

    const { data: ttns, refetch: refetchTtn } = useGetPageQuery(
        "ttns?per_page=30" + statusIdsParams + searchParams + pagination
    );
    const [deleteTtn, { isLoading, isError }] = useSendFormMutation();

    const checkAllHandler = () => {
        setTtnList(ttns.data.map((ttn) => ttn.order_id.toString()));
    };

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setTtnList([...ttnList, e.target.value]);
        } else if (!e.target.checked) {
            setTtnList([...ttnList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteProductsHandler = async () => {
        for (const ttn of ttnList) {
            await deleteTtn({ body: {}, url: "ttn/" + ttn, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchTtn();
    };

    return (
        <>
            {ttns && (
                <div className="content">
                    <ModalStatistics
                        showStatisticModal={showStatisticModal}
                        setShowStatisticModal={setShowStatisticModal}
                    />
                    <div className="co-12">
                        <div className="header-container mb-3">
                            <div className="header">
                                <h1>Відправки (2 ТТН)</h1>
                            </div>
                            <div className="header-functions">
                                {/* <div className="float-end mx-2 my-2">
                                    <div className="btn btn-primary" onClick={() => setShowStatisticModal(true)}>
                                        Статистика
                                    </div>
                                </div> */}
                                <div className="float-end my-2">
                                    <Link className="btn btn-primary" to={"/ttn"}>
                                        Додати ТТН
                                    </Link>
                                </div>
                                <div className="float-end  mx-2 my-2">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="nav-bordered nav nav-tabs mb-3">
                        {NPSatuses.map((status) => {
                            return (
                                <li className={"nav-item"} key={status.value}>
                                    <Link
                                        to={"/novaposhta/" + status.value}
                                        className={+statusParam === status.value ? "nav-link active" : "nav-link"}
                                    >
                                        <span className=" d-lg-block">{status.title}</span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <a className="check_all" onClick={checkAllHandler}>
                        Виділити все
                    </a>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th data-field="check"></th>

                                <th data-field="user_name">ТТН</th>
                                <th data-field="user_ttn">Статус</th>
                                <th data-field="user_address" className="no-mobile">
                                    Місто
                                </th>
                                <th data-field="user_date" className="no-mobile">
                                    Повернення
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ttns?.data.map((ttn) => {
                                return (
                                    <tr>
                                        <td className="check_area text-right">
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={ttnList.includes(ttn.order_id.toString())}
                                                    value={ttn.order_id}
                                                    onChange={(e) => listCheckHandler(e)}
                                                />
                                                <label className="custom-control-label">&nbsp;</label>
                                            </div>
                                        </td>

                                        <td>
                                            <Link to={"/ttn/" + ttn.ttn} data-id="47749">
                                                {ttn.ttn}
                                            </Link>
                                            <div>
                                                <span className="badge bg-info text-dark my-1 p-2">
                                                    <Link
                                                        to={"/order/" + ttn.order_id}
                                                        style={{
                                                            textDecoration: "none",
                                                            fontSize: 13,
                                                            fontWeight: 400,
                                                        }}
                                                    >
                                                        {"Замовлення #" + ttn.order_id}
                                                    </Link>
                                                </span>
                                            </div>

                                            <div className="w_time text-muted">
                                                {moment(ttn.created_at).format("DD.MM.YYYY")}
                                            </div>
                                        </td>
                                        <td>{getStatusTitle(ttn.status_id, ttn.city_to)}</td>
                                        <td className="no-mobile">
                                            {ttn.city_from}
                                            <i className="bi bi-arrow-right"></i>
                                            {ttn.city_to}
                                            <div className="text-muted">{ttn.address_to}</div>
                                        </td>
                                        <td className="no-mobile">{ttn.return_amount} грн.</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {permissions.includes("novaposhta_section") || permissions.includes("all") ? (
                        <div className="d-flex">
                            <select name="action" className="form-select" style={{ width: "auto" }}>
                                <option value="delete">Видалити</option>{" "}
                            </select>
                            <button className="btn btn-info mx-3" onClick={deleteProductsHandler}>
                                {isLoading ? "Завантаження" : "Виконати"}
                            </button>
                        </div>
                    ) : null}

                    <nav className="mt-3">
                        <PaginatedItems pageCount={ttns.last_page} setCurrentPage={setCurrentPage} />
                    </nav>
                </div>
            )}
        </>
    );
};

export default Novaposhta;
